import { defineStore } from 'pinia'
import router from '../router'
import http from '../services/http'
import { copyObject } from "../utils/helper"
import storage from "../services/localStorage"
import defIcon from '@/assets/img/logo.svg'

var _signinSettingsPromise = null

export const useAppStore = defineStore('app', {
    state: () => ({
        config: {
            appTitle: 'AppFramework',
            appIcon: null,
            showSearch: false,
            showNotification: false,
            searchPage: null,
            showProfile: true,
            alwaysShowSearch: false,
            showHome: true,
            sideBarShow: false,
            sideBarShowBorder: true,
            sideBarButtonStyle: 'rounded',
            sideBarShowSignout: true,
            sidBarHoverExpand: false,
            footerShow: true,
            footerContent: '&copy; 2022 PIX SOFT',
            homePage: null,
            userHomePage: null,
            buttonStyle: {
                outlined: true,
                text: false,
                rounded: true,
                icon: false,
                fab: false,
                tile: false,
                color: null,
            },
            toolbarButtonStyle: {
                outlined: true,
                text: false,
                rounded: true,
                icon: false,
                fab: false,
                tile: false,
                color: null,
            }
        },

        errorMessage: null,
        messageVisible: false,
        message: null,
        loading: false,
        projectMenus: [],

        messageBox: false,
        messageBoxMessage: null,
        messageBoxType: null,
        messageBoxSuccess: null,
        messageBoxCancel: null,

        inputBox: false,
        inputBoxTitle: 'Input Box',
        inputBoxValue: '',
        inputBoxSuccess: null,
        inputBoxCancel: null
    }),

    getters: {
        appIcon: (state) => state.config.appIcon ? state.config.appIcon : defIcon
    },

    actions: {
        showInputBox(title, value, success, cancel) {
            this.inputBoxTitle = title
            this.inputBoxValue = value
            this.inputBoxSuccess = success
            this.inputBoxCancel = cancel
            this.inputBox = true
        },
        showMessageBox(type = 'alert', message, success, cancel) {
            this.messageBox = true;
            this.messageBoxType = type;
            this.messageBoxMessage = message;
            this.messageBoxSuccess = success;
            this.messageBoxCancel = cancel;
        },
        hideMessageBox() {
            this.messageBoxSuccess = null;
            this.messageBoxCancel = null;
            this.messageBox = false;
        },
        isProjectExit(title) {
            for (let i = 0; i < this.projectMenus.length; i++) {
                if (title == this.projectMenus[i].title) return true
            }

            return false
        },
        addProjectMenu({ title = '', icon = '', type = '', page = '', url = '', role = null, children = null, area = null }) {
            this.projectMenus.push({
                title,
                icon,
                type,
                page,
                url,
                role,
                children,
                area
            })
        },
        addProjectMenus(menus) {
            for (let i = 0; i < menus.length; i++) {
                this.projectMenus.push(menus[i])
            }
        },
        showLoading() {
            this.loading = true;
        },
        hideLoading() {
            this.loading = false;
        },
        async init() {
            // get app config lastupdate
            const appConfigLastUpdate = Number(storage.getItem('appConfigLastUpdate', 0))
            const lastUpdateResult = await http.get('docs/pub/app/last-update')

            if (lastUpdateResult && appConfigLastUpdate < lastUpdateResult.lastUpdate) {
                // load app config from server
                const response = await http.get("docs/pub/app")

                if (response && response.content) {
                    const config = JSON.parse(response.content)
                    this.setConfig(config)
                }

                storage.setItem('appConfigLastUpdate', lastUpdateResult.lastUpdate)
            }
            else {
                // load from cache
                const sConfig = storage.getItem('app')

                if (sConfig) {
                    const config = JSON.parse(sConfig)
                    this.setConfig(config)
                }
            }
        },
        showMessage(message) {
            this.message = message
            this.messageVisible = true
        },
        hideMessage() {
            this.messageVisible = false
        },
        serverError(error) {
            this.errorMessage = error
            router.replace('/server-error')
        },
        setConfig(config) {
            copyObject(config, this.config)
            storage.setItem("app", JSON.stringify(config))
        },
        getSigninSettings(iconMode = 'mdi') {
            if (!_signinSettingsPromise) {
                _signinSettingsPromise = new Promise((resolve, reject) => {
                    http.get("account/signin_settings?icon=" + iconMode).then((response) => {
                        resolve(response)
                    }, (err) => {
                        reject(err)
                    }).catch((err) => {
                        reject(err)
                    })
                })
            }

            return _signinSettingsPromise
        },
        async updateConfig(config) {
            const payload = {
                content: JSON.stringify(config)
            };

            await http.post("docs/pub/app", payload)
            this.setConfig(config)
        }
    }
})
